<template>
  <div id="app">
    <div class="wrapper">
      <div class="calcTitle">
        <h3>Simula tu Financiamiento</h3>
      </div>
      <div class="calcContent">
        <div id="selectors">
          <div class="group">
            <label for="price">Precio (UF)</label>
            <input
              id="currency"
              v-model="price"
              type="text"
              name="price"
              :readonly="!editable"
              @blur="calculateMonthlyPayment"
            >
          </div>
          <div class="group">
            <div class="group-wrapper">
              <label for="down_payment">Pie</label>
              <div class="range-slider">
                <input
                  id="down_payment"
                  v-model="downPayment"
                  name="down_payment"
                  type="range"
                  min="0"
                  max="100"
                  step="5"
                  class="rs-range-line"
                >
                <span
                  id="rs-bullet"
                  class="rs-label"
                >
                  {{ downPayment + "%" }}
                </span>
              </div>
            </div>
          </div>

          <div class="group">
            <div class="group-wrapper">
              <label for="loan_percentage">Crédito</label>
              <div class="range-slider">
                <input
                  id="loan_percentage"
                  v-model="loanPercentage"
                  name="loan_percentage"
                  type="range"
                  min="0"
                  max="100"
                  step="5"
                  class="rs-range-line"
                >
                <span
                  id="rs-bullet"
                  class="rs-label"
                >
                  {{ loanPercentage + "%" }}
                </span>
              </div>
            </div>
          </div>

          <div class="group">
            <div class="group-wrapper">
              <label for="interest_rate">CAE</label>
              <div class="range-slider">
                <input
                  id="interest_rate"
                  v-model="interestRate"
                  name="interest_rate"
                  type="range"
                  min="0"
                  max="6"
                  step=".01"
                  class="rs-range-line"
                >
                <span
                  id="rs-bullet"
                  class="rs-label"
                >
                  {{
                    interestRate + "%"
                  }}
                </span>
              </div>
            </div>
          </div>

          <div class="group">
            <div class="group-wrapper">
              <label for="loan_term">Plazo</label>
              <div class="range-slider">
                <input
                  id="loan_term"
                  v-model="loanTerm"
                  name="loan_term"
                  type="range"
                  min="10"
                  max="50"
                  step="5"
                  class="rs-range-line blue-slider"
                >
                <span
                  id="rs-bullet"
                  class="rs-label blue-bullet"
                >
                  {{ loanTerm }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="values">
          <div class="group">
            <label for="estimated_rent">Arriendo Estimado</label>
            <input
              v-if="!editable"
              id="estimated_rent"
              v-model="estimatedRent"
              type="text"
              name="estimated_rent"
              readonly
            >
            <input
              v-else
              id="estimated_rent"
              v-model="estimatedRent"
              v-currency="{currency: 'CLP', locale: 'es-CL'}"
              value="0"
              style="width:100px"
            >
          </div>
          <div class="group">
            <label for="down_payment_amount">Pie (UF)</label>
            <input
              id="down_payment_amount"
              v-model="downPaymentAmount"
              type="text"
              name="down_payment_amount"
              readonly
            >
          </div>
          <div class="group">
            <label for="loan_amount">Crédito (UF)</label>
            <input
              id="loan_amount"
              v-model="loanAmount"
              type="text"
              name="loan_amount"
              readonly
            >
          </div>
          

          <div class="group">
            <label for="monthly_payment">Dividendo Mensual</label>
            <input
              id="monthly_payment"
              v-model="monthlyPayment"
              type="text"
              name="monthly_payment"
              readonly
            >
          </div>

          <div class="group">
            <label for="monthly_cash_flow">Flujo Caja Mensual *</label>
            <input
              id="monthly_cash_flow"
              v-model="monthlyCashFlow"
              type="text"
              name="monthly_cash_flow"
              readonly
            >
          </div>
        </div>
      </div>
      <div class="calcFooter">
        <p class="disclaimer">
          * No considera gastos de administración, contribuciones, derechos de basura, entre otros.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      uf: 0,
      price: 0,
      downPayment: 20,
      loanPercentage: 80,
      monthlyPayment: 0,
      estimatedRent: 0,
      monthlyCashFlow: 0,
      loanTerm: 30,
      interestRate: 3.5,
      loanAmount: 0,
      downPaymentAmount: 0,
      isChanging: false,
      wpata: wpData,
      editable: false
    };
  },
  watch: {
    downPayment: function( curr, prev ) {
      this.loanPercentage = 100 - curr;
      this.calculateMonthlyPayment();
    },
    loanPercentage: function( curr, prev ) {
      this.downPayment = 100 - curr;
      this.calculateMonthlyPayment();
    },
    loanTerm: function() {
      this.calculateMonthlyPayment();
    },
    interestRate: function() {
      this.calculateMonthlyPayment();
    },
    estimatedRent: function() {
      this.calculateMonthlyPayment();
    },
    price: function() {
      this.calculateMonthlyPayment();
    }
  },
  created: function() {
    this.uf = parseFloat( this.wpata.uf );
    this.estimatedRent = this.wpata.estimated_rent;
    this.price = ( this.wpata.price !== null  &&  this.wpata.price !== undefined ) ? parseFloat( this.wpata.price ) : 0;
    this.loanAmount = this.loanPercentage * this.price / 100;
    this.downPaymentAmount = this.downPayment * this.price / 100;
    this.editable = parseInt( this.wpata.editable );

    //this.price = 2536.35160275477;
    this.calculateMonthlyPayment();
  },
  mounted: function() {
   document.querySelectorAll( '[type="range"]' )
        .forEach( element => {
            element.addEventListener( 'mousemove', this.handleMove );
            element.addEventListener( 'touchmove', this.handleMove );
            element.addEventListener( 'mousedown', this.handleDown );
            element.addEventListener( 'touchdown', this.handleDown );
            element.addEventListener( 'touchstart', this.setCSSProperty );
            element.addEventListener( 'mouseup', this.handleUpAndLeave );
            element.addEventListener( 'mouseleave', this.handleUpAndLeave );
            element.addEventListener( 'touchcancel', this.setCSSProperty );
            element.addEventListener( 'click', this.setCSSProperty );
            element.addEventListener( 'touch', this.setCSSProperty );
        });

    document.querySelectorAll( '.rs-range-line' ).forEach( item => {
        item.addEventListener( 'input', this.updateSliderLabel, false );
    });

    this.setCSSProperty();
    this.updateSliderLabel();
  },
  methods: {
    formatCurrency: function( e ) {
      return new Intl.NumberFormat( 'es-CL', {
        style: 'currency',
        currency: 'CLP'
      }).format( parseFloat ( e.replace( /\D/g, '' ) ) );
    },
    calculateMonthlyPayment() {
      this.loanAmount = this.loanPercentage * this.price / 100;
      this.downPaymentAmount = this.downPayment * this.price / 100;

      const monthlyRate = Math.pow( 1 + this.interestRate / 100, 1 / 12 ) - 1;
      const loanAmount = ( this.price * this.loanPercentage ) / 100;
      const periods = 12 * this.loanTerm;
      const fraction = 1 + monthlyRate;

      const rent = parseInt(
        this.estimatedRent.replace( /\D/g, '' )
      );

      const aproxExpense = rent * 0.13 * -1;

      let amount =
        this.uf *
        loanAmount *
        monthlyRate *
        ( Math.pow( fraction, periods ) / ( Math.pow( fraction, periods ) - 1 ) );
      amount = isNaN( amount ) ? 0 : amount;
      this.monthlyPayment = new Intl.NumberFormat( 'es-CL', {
        style: 'currency',
        currency: 'CLP'
      }).format( parseInt( amount ) );
      let cashFlow =  -parseInt( amount ) + rent;
      cashFlow = isNaN( cashFlow ) ? 0 : cashFlow;
      this.monthlyCashFlow = new Intl.NumberFormat( 'es-CL', {
        style: 'currency',
        currency: 'CLP'
      }).format( parseInt( cashFlow ) );
    },
    setCSSProperty: function() {
        document.querySelectorAll( '[type="range"]' )
            .forEach( element => {
                const percent =
                    ( ( element.value - element.min ) /
                        ( element.max - element.min ) ) *
                    100;
                element.style.setProperty( '--webkitProgressPercent', `${percent}%` );

            });
    },
    handleMove: function() {
        if ( ! this.isChanging ) {
          return;
        }
        this.setCSSProperty();
    },
    handleUpAndLeave: function() {
      this.isChanging = false; this.setCSSProperty();
    },
    handleDown: function() {
      this.isChanging = true; this.setCSSProperty();
    },
    updateSliderLabel: function() {
      document.querySelectorAll( '[type="range"]' )
          .forEach( element => {
              const rangeSlider = element;
              const labelWidthOffset = rangeSlider.classList.contains( 'blue-slider' ) ? 30 : 15;
              const rangeBullet = rangeSlider.nextElementSibling;
              let bulletPosition = ( rangeSlider.value * rangeSlider.offsetWidth );
              let offset = ( bulletPosition / rangeSlider.max ) - labelWidthOffset;
              if ( 0 > offset ) {
                offset = 0;
              }
              if ( offset > rangeSlider.offsetWidth ) {
                offset = rangeSlider.offsetWidth;
              }
              rangeBullet.style.left = Math.floor( offset ) + 'px';
          });
    }
  }
};


</script>

<style lang='scss'>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
  float: left;
}
        .wrapper,
        .group {
            display: flex;
        }

        .wrapper {
          flex-wrap: wrap;
          margin: 20px 0px;
          flex-direction: column;
        }

        /*#selectors,
        #values{
          width: 100%;
        }*/

        .calcContent{
          flex-direction: row;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .calcFooter{
          display: flex;
        }

        .disclaimer{
          font-size: smaller;
        }

        .group {
            justify-content: space-between;
            padding: 10px;
        }

        .group-wrapper {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            width: 100%;
        }

        #app input[type='text'] {
          padding: 1px 2px;
          text-align: left;
        }

        #values input[type='text']{
            width: 100px;
        }

        /**/
        input[type='range'] {
            --thumbSize: 12px;
            --trackSize: 2px;
            --thumbBg: #f1c40f;
            --trackBg: #9b9a9a;
            --progressBg: #f1c40f;
              background: transparent;

            /* webkit progress workaround */
            --webkitProgressPercent: 0%;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            height: var(--thumbSize);
            width: 100%;
            margin: 0;
            padding: 0;
        }

        input[type='range']:focus {
            outline: none;
        }

        input[type='range'].blue-slider {
            --thumbBg: #5890dc;
            --progressBg: #5890dc;
        }

        /* Thumb */
        input[type='range']::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: var(--thumbSize);
            height: var(--thumbSize);
            background-color: var(--thumbBg);
            border-radius: calc(var(--thumbSize) / 2);
            border: none;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            margin-top: calc(((var(--thumbSize) - var(--trackSize)) / 2) * -1);
            cursor: pointer;
        }

        input[type='range']::-moz-range-thumb {
            -moz-appearance: none;
            appearance: none;
            width: var(--thumbSize);
            height: var(--thumbSize);
            background-color: var(--thumbBg);
            border-radius: calc(var(--thumbSize) / 2);
            border: none;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            margin-top: calc(((var(--thumbSize) - var(--trackSize)) / 2) * -1);
            cursor: pointer;
        }

        input[type='range']::-ms-thumb {
            -ms-appearance: none;
            appearance: none;
            width: var(--thumbSize);
            height: var(--thumbSize);
            background-color: var(--thumbBg);
            border-radius: calc(var(--thumbSize) / 2);
            border: none;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            margin-top: calc(((var(--thumbSize) - var(--trackSize)) / 2) * -1);
            cursor: pointer;
        }

        /* Track */
        input[type='range']::-webkit-slider-runnable-track {
            height: var(--trackSize);
            background-image: linear-gradient(90deg,
                    var(--progressBg) var(--webkitProgressPercent),
                    var(--trackBg) var(--webkitProgressPercent));
            border-radius: calc(var(--trackSize) / 2);
        }

        input[type='range']::-moz-range-track {
            height: var(--trackSize);
            background-color: var(--trackBg);
            border-radius: calc(var(--trackSize) / 2);
        }

        input[type='range']::-ms-track {
            height: var(--trackSize);
            background-color: var(--trackBg);
            border-radius: calc(var(--trackSize) / 2);
        }

        /* Progress */
        input[type='range']::-moz-range-progress {
            height: var(--trackSize);
            background-color: var(--progressBg);
            border-radius: calc(var(--trackSize) / 2) 0 0 calc(var(--trackSize) / 2);
        }

        input[type='range']::-ms-fill-lower {
            height: var(--trackSize);
            background-color: var(--progressBg);
            border-radius: calc(var(--trackSize) / 2) 0 0 calc(var(--trackSize) / 2);
        }

        .rs-label {
            color: #f1c40f;
            position: relative;
            transform-origin: center center;
            display: block;
            width: 30px;
            background: transparent;
            line-height: 1px;
            text-align: center;
            font-weight: bold;
            box-sizing: border-box;
            border: none;
            left: 0;
            font-style: normal;
            font-size: 12px;
        }

        .rs-label.blue-bullet {
            color: #5890dc;
        }

        .range-slider {
          /* flex-grow: 1; */
          width: 180px;
        }

        /**/

        .inputType {
            border: 2px solid rgb(118, 118, 118);
            font-size: 12px;
            line-height: 14px;
            padding: 1px 2px;
            border-style: inset;
            background: #ccc;
            font-family: Arial;
            font-weight: 400;
        }

        label {
            margin-right: 10px;
            /*idth: 20%;*/
        }

        @media only screen and (max-width: 768px) {
          #app {
            float: none;
          }
        }

        @media only screen and (max-width: 600px) {
          #selectors, #values {
            width: 100%;
          }
        }
</style>



// WEBPACK FOOTER //
// src/App.vue